function isBeacon() {
    return navigator.sendBeacon
}

function buildPost() {
    return new Function('var xhr=new XMLHttpRequest();xhr.open("POST",arguments[0],true);xhr.send(arguments[1]);');
}

function $post(url, data = {}) {
    if(navigator.sendBeacon) {
        navigator.sendBeacon(url, JSON.stringify(data))
    } else {
        const post = buildPost()
        post(url, JSON.stringify(data))
    }
}

function $get(url, success) {
    const img = new Image()
    img.style.display = "none"
    img.src = url
    document.body.appendChild(img);
    success && success()
    //删除Dom
    setTimeout(() => {
        document.body.removeChild(img)
    }, 50)
}

export default {
    isBeacon,
    $post,
    $get
}
